import {
  sketchfabLink,
  maxFileSize,
  youtubeLink,
  dimensions,
  isZipFile,
  required,
  alphaNum,
  checked,
  image,
  email,
  size,
  min,
  max,
  url,
} from '@helpers/validationRules.js'

export const DEFAULT_URL_EMAIL_MAX = 100
export const MAX_FILESIZE_8MB = 8388608
export const MAX_FILE_SIZE_20GB = 21474836480

export const loginConfig = {
  email: {
    required: true,
    email: true,
    max: DEFAULT_URL_EMAIL_MAX,
  },
  code: {
    required: true,
    alphaNum: true,
    size: 5,
  },
}

export const reportConfig = {
  name: {
    max: 100,
  },
  email: {
    max: DEFAULT_URL_EMAIL_MAX,
  },
  address: {
    max: 250,
  },
  urls: {
    max: 2560,
  },
  summary: {
    required: true,
    max: 10000,
  },
}

export const discussionConfig = {
  comment: {
    required: true,
    max: 5000,
  },
}

export const modBasicsConfig = {
  name: {
    required: true,
    max: 50,
  },
  name_id: {
    max: 50,
  },
  summary: {
    required: true,
    min: 10,
    max: 250,
  },
  homepage_url: {
    url: true,
    max: 150,
  },
  description: {
    max: 50000,
  },
  logo: {
    required: true,
    image: true,
    maxFileSize: MAX_FILESIZE_8MB,
    dimensions: { minWidth: 512, minHeight: 288 },
  },
  visible: {
    required: true,
  },
}

export const modFileConfig = {
  filedata: {
    zip: true,
    maxFileSize: MAX_FILE_SIZE_20GB,
  },
  version: {
    max: 50,
  },
  changelog: {
    max: 50000,
  },
  metadata_blob: {
    max: 50000,
  },
  terms: {
    checked: true,
  },
}

export const modMediaConfig = {
  youtube: {
    youtube: true,
    max: 255,
  },
  sketchfab: {
    sketchfab: true,
    max: 255,
  },
}

export const statusConfig = {
  reason: {
    required: true,
    max: 1000,
  },
}

export const monTermsConfig = {
  monTermsAgreed: {
    checked: true,
  },
}

function _getValidationFunctions(config) {
  const validationFunctions = {}

  for (let [field, validations] of Object.entries(config)) {
    validationFunctions[field] = Object.entries(validations).map(
      ([key, value]) => {
        if (key === 'required') return required
        if (key === 'min') return min(value)
        if (key === 'max') return max(value)
        if (key === 'checked') return checked
        if (key === 'url') return url
        if (key === 'image') return image
        if (key === 'dimensions') return dimensions(value)
        if (key === 'maxFileSize') return maxFileSize(value)
        if (key === 'zip') return isZipFile
        if (key === 'email') return email
        if (key === 'alphaNum') return alphaNum
        if (key === 'youtube') return youtubeLink
        if (key === 'sketchfab') return sketchfabLink
        if (key === 'size') return size(value)
        if (key === 'custom') return value
        throw new Error('Unrecognised validation function')
      }
    )
  }

  config.validation = validationFunctions
}

const _configs = [
  discussionConfig,
  modBasicsConfig,
  monTermsConfig,
  modMediaConfig,
  modFileConfig,
  reportConfig,
  statusConfig,
  loginConfig,
]

_configs.forEach((config) => _getValidationFunctions(config))
